import { IFormattedAssetItem, useMutation } from '@northladder/services';

import { INBOUND_API } from '../../../inboundAPIClient';

/**
 * This is to track the scan port for creating evaluation mutation keys in
 * react query cache.
 */
const SCAN_EVALUATED_APPRAISAL_MUTATION_KEY =
  'scan-evaluated-appraisal-mutation-key';

interface IUseScanEvaluatedAppraisalMutationParams {
  onSuccessCallback: (data: IFormattedAssetItem) => void;
}

/**
 * React Query mutation function for scanning an appraisal for getting info of an
 * evaluated appraisal.
 */
export const useScanEvaluatedAppraisalMutation = ({
  onSuccessCallback,
}: IUseScanEvaluatedAppraisalMutationParams) => {
  const {
    data,
    error,
    isError,
    isPending,
    mutate: scanEvaluatedAppraisal,
    reset: resetScanEvaluatedAppraisal,
  } = useMutation({
    mutationKey: [SCAN_EVALUATED_APPRAISAL_MUTATION_KEY],
    networkMode: 'always',
    mutationFn: INBOUND_API.scanEvaluatedAppraisal,
    onSuccess: onSuccessCallback,
  });

  return {
    data,
    error,
    isError,
    isPending,
    resetScanEvaluatedAppraisal,
    scanEvaluatedAppraisal,
  };
};
